const SET_ACTIVE = (state, payload) => {
  state.active = payload;
}

export default {
  SET_ACTIVE
}